// components
import GridPageAbstract from '../../abstract/GridPageAbstract';

export default class PaymentRefundsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'paymentRefunds';
        this.Server = this.props.context.getState().server.paymentRefunds;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'payment.uuid'];
        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'uuid',
                    label: 'refundUuid',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'paymentUuid',
                    label: 'paymentUuid',
                    alignRight: false,
                    cell: 'ServerSearch',
                    searchFields: ['uuid'],
                    outputField: 'uuid',
                    searchController: 'paymentInstances',
                    object: 'payment',
                    show: 'uuid',
                    displayGrid: true,
                    displayAdd: true,
                    disableEditor: true
                },
                {
                    id: 'paymentAmount',
                    label: 'paymentAmount',
                    alignRight: false,
                    cell: 'Text',
                    object: 'payment',
                    show: 'amount',
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'amount',
                    label: 'refundAmount',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'description',
                    label: 'description',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'commissionRefund',
                    label: 'commissionRefund',
                    alignRight: false,
                    cell: 'CommissionsTotal',
                    from: 'publicCommissions',
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true
                },
                {
                    id: 'state',
                    label: 'state',
                    alignRight: false,
                    cell: 'State',
                    items: ['initialize', 'processed', 'refused'],
                    // initial: 'initialize',
                    displayGrid: true,
                    hideOnAdd: true
                },
                {
                    id: 'stateDesc',
                    label: 'stateDesc',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'dateCreatedModified',
                    elements: ['dateCreated', 'dateModified'],
                    label: 'dateCreatedModified',
                    alignRight: false,
                    cell: 'CreateModify',
                    disableEditor: true,
                    displayGrid: true,
                    customSort: 'dateCreated',
                },
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
